import React from 'react';
import { ExitIcon } from '../../icons';

interface ResourceModalHeaderProps {
  onClose: () => void;
}

export const ResourceModalHeader: React.FC<ResourceModalHeaderProps> = ({ onClose }) => {
  return (
    <div className="border-input-border-gray flex shrink-0 items-center border-b px-[23px] py-4">
      <button
        onClick={onClose}
        className="flex h-9 w-9 items-center justify-center rounded-xl p-0"
        aria-label="Close modal"
      >
        <ExitIcon width={20} height={20} color="#101828" />
      </button>
    </div>
  );
};
